// extracted by mini-css-extract-plugin
export default {"root":"fileTree_root__Py8bC","folderIcon":"fileTree_folderIcon__4QrLW","folderTree":"fileTree_folderTree__axJMC","MuiTreeItem-label":"fileTree_MuiTreeItem-label__UrDxW"};